import { Component } from '@angular/core';

@Component({
        selector: 'sales-rep',
        template:`
        <router-outlet></router-outlet>

    `,
    styles: ['.example-card { max-width: 300px; }']
  })
export class SalesRepComponent {

  title: string = 'sales-rep';
}
